import { Contact } from '@features/contacts/types/contact'
import { Account } from '@modules-deprecated/app/accounts/types'
import { TaxRate } from '@modules-deprecated/app/taxrates/types'

import { autoCompleteBillForm } from '../utils/autoCompleteBillForm'
import { BillForm } from '../utils/formData'
import { getBillFormFromVendorData } from '../utils/getBillFormFromVendorData'

interface GetVendorAutoCompleteProps {
  accounts?: Account[]
  baseCurrencyId?: string
  billForm: BillForm
  locale: string
  organizationId: string | undefined
  organizationCountryCode: string
  taxRates?: TaxRate[]
  vendor: Partial<Contact>
}

export const getAutoCompletedFormWithVendor = async ({
  accounts,
  baseCurrencyId,
  billForm,
  locale,
  organizationId,
  organizationCountryCode,
  taxRates,
  vendor,
}: GetVendorAutoCompleteProps): Promise<BillForm> => {
  /* If we are here, vendor is changing. We need to get rid of previous data blocked by vendor */
  /* We only ever prefill first line */
  if (billForm.billLines) {
    billForm.billLines[0].lockedByVendor = false
  }

  const billFormVendor = await getBillFormFromVendorData({
    accounts,
    billForm,
    locale,
    organizationId,
    organizationCountryCode,
    taxRates,
    vendor,
  })

  const billFormUpdated = autoCompleteBillForm({
    billFormDefault: billForm,
    billFormOverrides: billFormVendor,
    baseCurrencyId,
  })

  /* If new vendor data has been autofilled, we want to lock it, as vendor data takes priority over other prefills */
  /* We only ever prefill first line */
  if (billFormUpdated.billLines) {
    billFormUpdated.billLines[0].lockedByVendor = !!vendor
  }

  return billFormUpdated
}
